import React from 'react';
import styled from 'styled-components';
import { Color } from 'core';

interface StepIndicatorProps {
  steps: string[];
  activeStep: number; // 1-indexed
}

export const StepIndicator = ({ steps, activeStep }: StepIndicatorProps) => {
  return (
    <>
      <StepContainer>
        {steps.map((stepLabel, index) => (
          <React.Fragment key={index}>
            <Step>
              <StepNumber active={index + 1 <= activeStep}>
                {index + 1}
              </StepNumber>
              <StepLabel active={index + 1 <= activeStep}>
                {stepLabel}
              </StepLabel>
            </Step>
            {index < steps.length - 1 && <StepConnector active={index + 1 < activeStep} />}
          </React.Fragment>
        ))}
      </StepContainer>
      <StepTitle>Step {activeStep} of {steps.length}</StepTitle>
    </>
  );
};

const StepContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  margin-top: 0;
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const StepNumber = styled.div<{ active?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(props) => (props.active ? Color.primaryBlue : '#E5E5E5')};
  color: ${(props) => (props.active ? 'white' : '#999')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
`;

const StepLabel = styled.div<{ active?: boolean }>`
  font-size: 14px;
  color: ${(props) => (props.active ? Color.primaryBlack : '#999')};
  font-weight: 500;
`;

const StepConnector = styled.div<{ active?: boolean }>`
  width: 80px;
  height: 2px;
  background: ${(props) => (props.active ? Color.primaryBlue : '#e5e5e5')};
  margin: 0 20px;
  margin-bottom: 24px;
`;

const StepTitle = styled.h3`
  text-align: center;
  font-size: 16px;
  color: #666;
  margin: 0 0 8px 0;
  margin-top: 0;
  font-weight: 400;
`;